module.exports = __webpack_public_path__ + "static/features-slide2@2x-62e2b87771bd642be71a0474dc363013.png";